import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Researcher sign-in is now shared by both marketplace sides. Keep this route
 * for old bookmarks and links while making `/login` the canonical entry point.
 */
export const Route = createFileRoute('/researchers/login')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/login', search });
  },
});
